import apiClient from './api';

export const programService = {
  // Get all programs
  getAllPrograms: async () => {
    const response = await apiClient.get('/programs');
    return response.data;
  },

  // Get user's programs with purchase status
  getMyPrograms: async () => {
    const response = await apiClient.get('/programs/my/programs');
    return response.data;
  },

  // Get single program by ID
  getProgramById: async (id) => {
    const response = await apiClient.get(`/programs/${id}`);
    return response.data;
  },

  // Get detailed program content (requires auth)
  getProgramContent: async (id) => {
    const response = await apiClient.get(`/programs/${id}/content`);
    return response.data;
  },

  // Admin: get program content
  getProgramContentAdmin: async (id) => {
    const response = await apiClient.get(`/programs/admin/${id}/content`);
    return response.data;
  },

  // Admin: create or update program content
  saveProgramContent: async (id, content) => {
    const response = await apiClient.post(`/programs/admin/${id}/content`, content);
    return response.data;
  },

  // Admin: delete program content
  deleteProgramContent: async (id) => {
    const response = await apiClient.delete(`/programs/admin/${id}/content`);
    return response.data;
  },

  // User progress per program
  getProgress: async (programId) => {
    const response = await apiClient.get(`/programs/${programId}/progress`);
    return response.data;
  },

  unlockNextDay: async (programId) => {
    const response = await apiClient.post(`/programs/${programId}/next`);
    return response.data;
  },

  // Mark program as completed (after upsell dismissal)
  completeProgram: async (programId) => {
    const response = await apiClient.post(`/programs/${programId}/complete`);
    return response.data;
  },

  // Create new program (admin)
  createProgram: async (programData) => {
    const response = await apiClient.post('/programs', programData);
    return response.data;
  },

  // Update program (admin)
  updateProgram: async (id, programData) => {
    const response = await apiClient.put(`/programs/${id}`, programData);
    return response.data;
  },

  // Delete program (admin)
  deleteProgram: async (id) => {
    const response = await apiClient.delete(`/programs/${id}`);
    return response.data;
  },

  // Upload program image
  uploadImage: async (formData) => {
    const response = await apiClient.post('/upload/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  // Razorpay order creation for a program
  createOrder: async (programId, offerId = null) => {
    const response = await apiClient.post('/razorpay/order', { program_id: programId, offer_id: offerId });
    return response.data;
  },

  // Razorpay payment verification and access grant
  verifyPayment: async (orderId, paymentId, signature, programId, offerId = null) => {
    const response = await apiClient.post('/razorpay/verify', {
      order_id: orderId,
      payment_id: paymentId,
      signature,
      program_id: programId,
      offer_id: offerId,
    });
    return response.data;
  },

  // Get all uploaded images
  getAllImages: async () => {
    const response = await apiClient.get('/upload');
    return response.data;
  },

  // Delete image
  deleteImage: async (filename) => {
    const response = await apiClient.delete(`/upload/${filename}`);
    return response.data;
  }
};

export default programService;
